// extracted by mini-css-extract-plugin
export default {"contenedor":"VerificarCorreo_contenedor__FWjaN","mensajeExito":"VerificarCorreo_mensajeExito__2Qakx","mensajeError":"VerificarCorreo_mensajeError__T8X99"};